import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  investorFormList,
  noticesAgendaList,
  additionalInfo,
  getAgendaMonth,
} from "../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import "./style.scss";
import "../style.scss";
import { formDataGenerator, getRouting } from "../../../../../utils/common";
import Modalreact from "react-modal";

const FormsandDisclosures = (props) => {
  const {
    investorFormList,
    investorListData,
    noticesAgendaList,
    noticesAgendaData,
    additionalInfo,
    additionalInfoData,
    getAgendaMonth,
    getAgendaMonthData,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case "forms":
        return 0;
      case "addenda-notices":
        return 1;
      case "additional-info":
        return 2;
      default:
        return 0;
    }
  };
  //Formacord start
  const current = pathname.split("/")[3];
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [currentPageurl, setCurrentPageurl] = useState("");
  const [formSelected, setformSelected] = useState(null);
  const [investorFormDataa, setinvestorFormDataa] = useState();
  const [noticesAgendaFormData, setnoticesAgendaFormData] = useState();
  const [addInfoLinkData, setaddInfoLinkData] = useState();
  const [additionalSearch, setadditionalSearch] = useState("");
  const [formSearch, setformSearch] = useState("");
  const [addendaSearch, setaddendaSearch] = useState("");
  const [metaData, setMetaData] = useState();
  const [addendayear, setaddendayear] = useState();
  const [monthValue, setMonthValue] = useState("");
  const [yearValue, setYearValue] = useState("");
  const [mothnData, setmothnData] = useState("");
  const [flag , setFlag] = useState(false);

  useEffect(() => {
    if (current) {
      setCurrentPageurl(current);
    }
  }, [current]);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  // useEffect(() => {
  //   // if (currentPageurl == "forms") {
  //   //   investorFormList();
  //   // }
  //   // if (currentPageurl == "addenda-notices") {
  //   //   noticesAgendaList();
  //   // }
  // }, [currentPageurl]);

  useEffect(() => {
    if (currentPageurl === "forms") {
      let formData = {
        search: formSearch ? formSearch : "",
      };
      !(investorListData && 
        investorListData.investorSevicesForm && flag == false) && 
      investorFormList(formDataGenerator(formData));
    }
    if (currentPageurl === "additional-info") {
      let formData = {
        search: additionalSearch ? additionalSearch : "",
      };
      !(additionalInfoData &&
        additionalInfoData.additionainfo && flag == false) &&
      additionalInfo(formDataGenerator(formData));
    }

    if (currentPageurl === "addenda-notices") {
      let formData = {
        search: addendaSearch ? addendaSearch : "",
        year: yearValue ? yearValue : "",
      };
      !(noticesAgendaData &&
        noticesAgendaData.noticeAgenda && flag == false) &&
      noticesAgendaList(formDataGenerator(formData));
      let formaddendaData = {
        year: "",
      };
    }
  }, [currentPageurl, additionalSearch, formSearch, addendaSearch]);
  
  useEffect(()=>{
    if (currentPageurl === "addenda-notices") {
      let formaddendaData = {
        year: "",
      };
      !(getAgendaMonthData && getAgendaMonthData.agendamonth && flag == false) &&
      getAgendaMonth(formDataGenerator(formaddendaData));
    }
  },[currentPageurl])


  useEffect(() => {
    if (currentPageurl === "forms") {
      setSelectedIndexTab(0);
    }
    if (currentPageurl === "addenda-notices") {
      setSelectedIndexTab(1);
    }
    if (currentPageurl === "additional-info") {
      setSelectedIndexTab(2);
    }
  }, [currentPageurl]);

  useEffect(() => {
    if (
      investorListData &&
      investorListData.investorSevicesForm &&
      investorListData.investorSevicesForm.investorsForms
    ) {
      setinvestorFormDataa(investorListData.investorSevicesForm.investorsForms);
    }
  }, [investorListData]);

  useEffect(() => {
    if (
      noticesAgendaData &&
      noticesAgendaData.noticeAgenda &&
      noticesAgendaData.noticeAgenda.investorsDocuments
    ) {
      setnoticesAgendaFormData(
        noticesAgendaData.noticeAgenda.investorsDocuments
      );
    }
    if (
      noticesAgendaData &&
      noticesAgendaData.noticeAgenda &&
      noticesAgendaData.noticeAgenda.Years
    ) {
      setaddendayear(noticesAgendaData.noticeAgenda.Years);
    }
  }, [noticesAgendaData]);

  useEffect(() => {
    if (
      additionalInfoData &&
      additionalInfoData.additionainfo &&
      additionalInfoData.additionainfo.information
    ) {
      setaddInfoLinkData(additionalInfoData.additionainfo.information);
    }
  }, [additionalInfoData]);

  useEffect(() => {
    if (
      currentPageurl === "forms" &&
      investorListData &&
      investorListData.investorSevicesForm &&
      investorListData.investorSevicesForm.meta
    ) {
      setMetaData(investorListData.investorSevicesForm.meta);
    }

    if (
      currentPageurl === "addenda-notices" &&
      investorListData &&
      investorListData.noticeAgenda &&
      investorListData.noticeAgenda.meta
    ) {
      setMetaData(investorListData.noticeAgenda.meta);
    }

    if (
      currentPageurl === "additional-info" &&
      investorListData &&
      investorListData.additionainfo &&
      investorListData.additionainfo.meta
    ) {
      setMetaData(investorListData.additionainfo.meta);
    }
  }, [currentPageurl, investorListData]);

  useEffect(() => {
    if (getAgendaMonthData && getAgendaMonthData.agendamonth) {
      setmothnData(getAgendaMonthData.agendamonth);
    }
  }, [getAgendaMonthData]);

  const formtoggle = (index) => {
    if (formSelected === index) {
      return setformSelected(null);
    }
    setformSelected(index);
  };
  //Formacord end
  //noticeacord start
  const [noticeSelected, setnoticeSelected] = useState(null);
  const noticetoggle = (index) => {
    if (noticeSelected === index) {
      return setnoticeSelected(null);
    }
    setnoticeSelected(index);
  };

  //modalacord start
  const [modalacord, setmodalacord] = useState(null);
  const modaltoggle = (index) => {
    if (modalacord === index) {
      return setmodalacord(null);
    }
    setmodalacord(index);
  };

  //modalacord end
  //modal

  const [isOpenModel, setIsOpenModel] = useState(false);

  const openModal = () => {
    setIsOpenModel(true);
  };

  const closeModal = () => {
    setIsOpenModel(false);
  };

  const handleApiCall = async (e, tabName) => {
    setCurrentPageurl(tabName);
    setformSearch("");
    setaddendaSearch("");
    setadditionalSearch("");
    setFlag(true);
  };

  const handleAdditionalSearch = (e) => {
    setadditionalSearch(e.target.value);
    setFlag(true);
  };
  const handleFormSearch = (e) => {
    setformSearch(e.target.value);
    setFlag(true);
  };
  const handleaddendaSearch = (e) => {
    setaddendaSearch(e.target.value);
    setFlag(true);
  };
  const handlechangereset = () => {
    setformSearch("");
    setaddendaSearch("");
    setadditionalSearch("");
    setFlag(true);
  };

  const handleMonth = async (e) => {
    setMonthValue(e.target.value);
    // let formData={
    //   year: yearValue ? yearValue : "",
    //   month: e.target.value ? e.target.value :'',
    // };
    // noticesAgendaList(formDataGenerator(formData));
  };

  const handleYear = async (e) => {
    setYearValue(e.target.value);
    let formData = {
      year: e.target.value ? e.target.value : "",
    };
    getAgendaMonth(formDataGenerator(formData));
  };

  const handleFilter = () => {
    setIsOpenModel(false);
    let formData = {
      year: yearValue ? yearValue : "",
      month: monthValue ? monthValue : "",
    };
    noticesAgendaList(formDataGenerator(formData));
  };
  const handleClearFilter = () => {
    setYearValue("");
    setMonthValue("");
    let formaddendaData = {
      year: "",
      month: "",
    };
    noticesAgendaList(formDataGenerator(formaddendaData));

    let formaddendaDataMonth = {
      year: "",
    };
    getAgendaMonth(formDataGenerator(formaddendaDataMonth));
  };
  return (
    <div className="wrapper">
      {metaData ? (
        <Helmet>
          <title>{metaData && metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={
              metaData && metaData.description ? metaData.description : ""
            }
          />
          <meta
            name="keywords"
            content={metaData && metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData && metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={
              metaData && metaData.og_description ? metaData.og_description : ""
            }
          />
          <meta
            property="og:image"
            content={metaData && metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData && metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      ) : (
        ""
      )}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex">
            <h1 className="me-auto">
              <span>Forms and</span> Disclosures
            </h1>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/investor-services">Investor Services</a>
                </li>
                <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  Forms And Disclosure
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <div className="container">
        <p className="py-4">
        Access essential investment documents and regulatory disclosures in our 'Forms and Disclosure' section.
        </p>
      </div>
      <section className="customSlick">
        <Tabs className="customTab container" selectedIndex={selectedIndexTab}>
          <TabList>
            <Link
              to={getRouting(
                "/investor-services/form-disclosures/forms",
                "Forms"
              )}
            >
              <Tab
                onClick={async (e) => await handleApiCall(e, "forms")}
                tabFor="0"
                value={0}
              >
                <div>
                  <p>Forms</p>
                </div>
              </Tab>
            </Link>
            <Link
              to={getRouting(
                "/investor-services/form-disclosures/addenda-notices",
                "Agenda Notices"
              )}
            >
              <Tab
                onClick={async (e) => await handleApiCall(e, "addenda-notices")}
                tabFor="1"
                value={1}
              >
                <div>
                  <p>Addenda & Notices</p>
                </div>
              </Tab>
            </Link>
            <Link
              to={getRouting(
                "/investor-services/form-disclosures/additional-info",
                "Additional Information"
              )}
            >
              <Tab
                onClick={async (e) => await handleApiCall(e, "additional-info")}
                tabFor="2"
                value={2}
              >
                <div>
                  <p>Additional Information</p>
                </div>
              </Tab>
            </Link>
          </TabList>
          <TabPanel>
            <div className="forms">
              <div>
                {/* <h3 className="mt-5 mb-2 fs">Forms</h3> */}
                <div className="row mb-4 mt-5">
                  <div className={formSearch ? "col-md-5 d-flex" : "col-md-4"}>
                    <div className="input-group iggroup mb-3">
                      <span
                        className="input-group-text serchcolor"
                        id="inputGroup-sizing-default"
                      >
                        <img
                          className="search"
                          src="/images/New/grey-search.svg"
                          alt="search"
                        />
                      </span>
                      <input
                        type="text"
                        className="form-control searchb ps-0"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        placeholder="Search.."
                        onChange={handleFormSearch}
                        value={formSearch}
                      />
                      
                    </div>
                    {formSearch ? (
                      <div
                        className="reset iggroup btn btn-outline-primary"
                        onClick={handlechangereset}
                      >
                        Reset
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="custAccordian pb-4">
                <div className="accordian Formacord">
                  {investorFormDataa &&
                    investorFormDataa.length > 0 &&
                    investorFormDataa.map((item, index) => (
                      <div className="item">
                        <div
                          className="title"
                          onClick={() => formtoggle(index)}
                        >
                          <div>
                            <h2>{item.title ? item.title : ""}</h2>
                          </div>
                          <div>
                            <img
                              className={formSelected === index ? "rotate" : ""}
                              src="/images/New/redDownArrow.svg"
                            />
                          </div>
                        </div>

                        <div
                          className={
                            formSelected === index ? "content show" : "content"
                          }
                        >
                          <div>
                            {item.values &&
                              item.values.length > 0 &&
                              item.values.map((row) => (
                                <a
                                  href={row.file && row.file.url}
                                  target="_blank"
                                >
                                  <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="d-flex align-items-center">
                                      <img
                                        src="/images/New/pdf.png"
                                        alt="pdfimg"
                                      />
                                      <h2 className="ms-2">
                                        {row.title ? row.title : ""}
                                      </h2>
                                    </div>
                                    <div className="d-flex justify-content-end sidearrow">
                                      <img
                                        src="/images/New/red-arrow.svg"
                                        alt="sidearrow"
                                        width={15}
                                        height={15}
                                      />
                                    </div>
                                  </div>
                                </a>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="forms">
              <div>
                {/* <h3 className="mt-5 mb-2 fs">Addenda & Notices</h3> */}
                <div className="mt-3 mb-4">
                  <div className="d-flex justify-content-between mt-5">
                    <div className="row w-100">
                      <div
                        className={
                          addendaSearch ? "col-md-5 d-flex" : "col-md-4"
                        }
                      >
                        <div className="input-group iggroup mb-3">
                          <span
                            className="input-group-text serchcolor"
                            id="inputGroup-sizing-default"
                          >
                            <img
                              className="search"
                              src="/images/New/grey-search.svg"
                              alt="search"
                            />
                          </span>
                          <input
                            type="text"
                            className="form-control searchb ps-0"
                            aria-label="Sizing example input"
                            aria-describedby="inputGroup-sizing-default"
                            placeholder="Search.."
                            onChange={handleaddendaSearch}
                            value={addendaSearch}
                          />
                          
                        </div>
                        {addendaSearch ? (
                          <div
                            className="reset iggroup btn btn-outline-primary"
                            onClick={handlechangereset}
                          >
                            Reset
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div>
                      <div
                        className="d-flex filter-border align-items-center mb-2"
                        onClick={openModal}
                      >
                        <img src="/images/New/filter-red.svg" alt="Filter Icon" />
                        <p className="filter-text d-none d-md-block">Filter</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {noticesAgendaFormData &&
                    noticesAgendaFormData.length > 0  ? 
              <div className="custAccordian pb-5">
                <div className="accordian noticeacord">
                  {noticesAgendaFormData &&
                    noticesAgendaFormData.length > 0 &&
                    noticesAgendaFormData.map((item, index) => (
                      <div className="item">
                        <div
                          className="title"
                          onClick={() => noticetoggle(index)}
                        >
                          <div>
                            <h2>{item.title ? item.title : ""}</h2>
                          </div>
                          <div>
                            <img
                              className={
                                noticeSelected === index ? "rotate" : ""
                              }
                              src="/images/New/redDownArrow.svg"
                            />
                          </div>
                        </div>

                        <div
                          className={
                            noticeSelected === index
                              ? "content show"
                              : "content"
                          }
                        >
                          <div>
                            {item.values &&
                              item.values.length > 0 &&
                              item.values.map((row) => (
                                <a
                                  href={row.file && row.file.url}
                                  target="_blank"
                                >
                                  <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="d-flex align-items-center">
                                      <img
                                        src="/images/New/pdf.png"
                                        alt="pdfimg"
                                      />
                                      <h2 className="ms-2">
                                        {row.title ? row.title : ""}
                                      </h2>
                                    </div>
                                    <div className="d-flex justify-content-end sidearrow">
                                      <img
                                        src="/images/New/red-arrow.svg"
                                        alt="sidearrow"
                                        width={15}
                                        height={15}
                                      />
                                    </div>
                                  </div>
                                </a>
                              ))}
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              :''}
            </div>
          </TabPanel>
          <TabPanel>
            <div className="forms">
              <div>
                {/* <h3 className="mt-5 mb-2 fs">Additional Information</h3> */}
                <div className="row mb-4 mt-5">
                  <div
                    className={
                      additionalSearch ? "col-md-5 d-flex" : "col-md-4"
                    }
                  >
                    <div className="input-group iggroup mb-3">
                      <span
                        className="input-group-text serchcolor"
                        id="inputGroup-sizing-default"
                      >
                        <img
                          className="search"
                          src="/images/New/grey-search.svg"
                          alt="search"
                        />
                      </span>
                      <input
                        type="text"
                        className="form-control searchb ps-0"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-default"
                        placeholder="Search.."
                        onChange={handleAdditionalSearch}
                        value={additionalSearch}
                      />
                      
                    </div>
                    {additionalSearch ? (
                      <div
                        className="reset iggroup btn btn-outline-primary"
                        onClick={handlechangereset}
                      >
                        Reset
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div>
                {addInfoLinkData &&
                  addInfoLinkData.links &&
                  addInfoLinkData.links.length > 0 &&
                  addInfoLinkData.links.length > 0 ?
                  addInfoLinkData.links.map((item) => (
                    <a href={item.link && item.link.uri} target="_blank">
                      <div className="bgw d-flex justify-content-between align-items-center p-4 mb-3">
                        <div className="d-flex align-items-center">
                          <img src={item.link && item.link.iconUrl ?  item.link.iconUrl : ''} alt={item.link && item.link.iconAlt ?  item.link.iconAlt : ''} className="link-icon" width={30} height={30}/>
                          <h2 className="ms-2 texts">
                            {item.link && item.link.title}
                          </h2>
                        </div>
                        <div className="d-flex justify-content-end sidearrow">
                          <img src="/images/New/redarrow.svg" />
                        </div>
                      </div>
                    </a>
                  )) : 
                  <div className="bgw p-4 mb-4">
                <h2>No Result Found</h2>
              </div>}
              </div>
            </div>
          </TabPanel>
        </Tabs>
      </section>
      <Modalreact
        isOpen={isOpenModel}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="mediafilter"
      >
        <div className="mediapannel">
          <div className="d-flex justify-content-between w-100 align-items-center px-3 py-2">
            <p className="filtertitle">Filter</p>
            <svg width="35" height="35" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={closeModal} className="cursorp">
              <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="rgba(111,111,111,0.1)" />
              <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div className="mediadiv">
            <Tabs>
              <TabList>
                <Tab>
                  <p>Search by year</p>
                </Tab>
                <Tab>
                  <p>Select month</p>
                </Tab>
              </TabList>
              <TabPanel>
                <div className="panel-content">
                
                  {addendayear &&
                    addendayear.values &&
                    Object.keys(addendayear.values).length > 0 &&
                    Object.keys(addendayear.values).map(
                      (yearval, yearindex) => {
                        return (
                          <div className="form-check">
                            <input
                              className="form-check-input d-none"
                              type="radio"
                              name="flexRadioYearDefault"
                              checked={yearval === yearValue}
                              value={yearval}
                              id={`flexRadioDefault11${yearindex}`}
                              onChange={handleYear}
                            />
                            <label
                              className="form-check-label"
                              for={`flexRadioDefault11${yearindex}`}
                            >
                              {Object.values(addendayear.values)[yearindex]}
                            </label>
                          </div>
                        );
                      }
                    )}
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-content">
                  {mothnData &&
                    mothnData.months &&
                    Object.keys(mothnData.months).length > 0 &&
                    Object.keys(mothnData.months).map((month, monthindex) => {
                      return (
                        <div className="form-check">
                          <input
                            className="form-check-input d-none"
                            type="radio"
                            name="flexRadioMonthDefault"
                            checked={month === monthValue}
                            value={month}
                            id={`flexRadioDefault${monthindex}`}
                            onChange={handleMonth}
                          />
                          <label
                            className="form-check-label"
                            for={`flexRadioDefault${monthindex}`}
                          >
                            {Object.values(mothnData.months)[monthindex]}
                          </label>
                        </div>
                      );
                    })}
                </div>
              </TabPanel>
            </Tabs>
            <div className="mediabtn">
              <div
                className="btn btn-outline-primary"
                onClick={handleClearFilter}
              >
                Clear Filters
              </div>
              <div className="btn btn-primary" onClick={handleFilter}>
                Apply
              </div>
            </div>
          </div>
        </div>
      </Modalreact>
    </div>
  );
};

const mapStateToProps = (state) => ({
  investorListData: state.InvesterServices,
  noticesAgendaData: state.InvesterServices,
  additionalInfoData: state.InvesterServices,
  getAgendaMonthData: state.InvesterServices,
});

const mapDispatchToProps = (dispatch) => ({
  investorFormList: bindActionCreators(investorFormList, dispatch),
  noticesAgendaList: bindActionCreators(noticesAgendaList, dispatch),
  additionalInfo: bindActionCreators(additionalInfo, dispatch),
  getAgendaMonth: bindActionCreators(getAgendaMonth, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FormsandDisclosures);
